import { Component } from 'react'
import Lottie from 'react-lottie'
import * as animationData from 'assets/animation/thankyou2.json'

export default class Animation extends Component {

  state = {
    direction: 1,
  }

  render() {

    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return <div id="thank-you-2-screen-animation">
      <Lottie
        options={defaultOptions}
        width={"50%"}
        direction={this.state.direction}
        isStopped={this.state.isStopped}
        isPaused={this.state.isPaused}
        eventListeners={[
          {
            eventName: 'complete',
            callback: (e) => this.setState({ direction: this.state.direction * -1 }),
          },
        ]}
      />
    </div>
  }
}
